<template>
  <!-- 绑定医师界面 -->
  <div class="bind-wrapper">
    <template v-if="dataDone">
      <div class="bind-header">
        <div class="doctor-card">
          <div class="card-head">医生信息</div>
          <div class="card-content">
            <div class="doctor-avatar">
              <div class="avatar-box"><img :src="docInfo.avatar"></div>
              <div class="link-icon">
                <icon icon-class="bind"></icon>
              </div>
            </div>
            <div class="doc-info">
              <div class="name-title">
                <h3>{{docInfo.username}}</h3>
                <span>{{docInfo.title | jobTitleFilter}}</span>
              </div>
              <div class="job">{{docInfo.p_dep}} | {{docInfo.dep}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="next"><button class="next-button" @click="bindingAction">确认绑定</button></div>
      <div class="rechoose" @click="backToChoose" v-if="back">重新选择</div>
    </template>

    <x-dialog v-if="dialogShow" @close="dialogShow = false" title="重新绑定">
      <div class="rebinding-wrapper">
        <div class="rebinding-text">
          <p>已绑定相同科室医生</p>
          <div class="old-doctor">{{oldDoc}} {{docInfo.p_dep}} | {{docInfo.dep}}</div>
          <div class="warning">是否解绑并绑定新医生</div>
        </div>
        <div class="control">
          <button class="cancel" @click="dialogShow = false">我再想想</button>
          <button class="confirm" @click="confirm" :disabled="confirming">确定</button>
        </div>
      </div>
    </x-dialog>
  </div>
</template>

<style lang="less" scoped>
  .bind-wrapper{
    .bind-header{
      position: relative;
      width: 100%;
      height: 136px;
      background: @linear;
      padding: 28px 20px 0;
      .doctor-card{
        background: #FFF;
        box-shadow: 0px 4px 10px 0px rgba(51,51,51,0.08);
        border-radius: 6px;
        overflow: hidden;
        .card-head{
          height: 56px;
          line-height: 56px;
          padding: 0 20px;
          font-size: 18px;
          color: @xile;
          font-weight: bold;
          .xile-alpha(0.15);
        }
        .card-content{
          height: 108px;
          padding: 20px;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          .doctor-avatar{
            position: relative;
            width: 56px;
            height: 56px;
            flex-shrink: 0;
            .avatar-box{
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 50%;
              overflow: hidden;
              img{
                width: 100%;
              }
            }
            .link-icon{
              display: flex;
              justify-content: center;
              align-items: center;
              color: #FFF;
              position: absolute;
              right: -4px;
              bottom: -4px;
              width: 24px;
              height: 24px;
              background: @xile;
              box-shadow: 0px 2px 6px 0px rgba(0,132,138,0.2);
              border-radius: 50%;
            }
          }
          .doc-info{
            padding-left: 16px;
            margin-top: 4px;
            .name-title{
              display: flex;
              justify-content: flex-start;
              align-items: center;
              h3{
                font-size: 18px;
                line-height: 24px;
                color: @black;
                font-weight: bold;
              }
              span{
                margin-left: 8px;
                font-size: 14px;
                line-height: 14px;
                color: #999;
                white-space: nowrap;
              }
            }
            .job{
              margin-top: 6px;
              font-size: 14px;
              line-height: 14px;
              color: #666;
            }
          }
        }
      }
    }
    .next{
      margin-top: 96px;
      padding: 0 56px;
      .next-button{
        @button-base();
        width: 100%;
        height: 36px;
      }
    }
    .rechoose{
      margin-top: 24px;
      text-align: center;
      font-size: 14px;
      line-height: 14px;
      color: #666;
    }
  }
  // 弹窗样式
  .rebinding-wrapper{
    padding: 40px 0 32px;
    text-align: center;
    .rebinding-text{
      font-weight: bold;
      p{
        font-size: 16px;
        line-height: 16px;
        color: @black;
      }
      .old-doctor{
        margin-top: 12px;
        font-size: 18px;
        line-height: 18px;
        color: @error;
      }
      .warning{
        margin-top: 16px;
        font-size: 14px;
        line-height: 14px;
        color: #666;
        font-weight: normal;
      }
    }
    .control{
      margin-top: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      button{
        @button-base();
        height: 36px;
        font-size: 14px;
        width: 128px;
        &.cancel{
          background: #FFF;
          border: 1px solid #999;
          color: #999;
          margin-right: 15px;
        }
        &.confirm{}
      }
    }
  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  export default {
    data() {
      return {
        dataDone: false,
        dialogShow: false,
        back: true,
        docInfo: {},
        // 重复医生信息
        oldDoc: '',
        oldId: null,
        confirming: false,
        refer_userid:0,
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      if (this.$route.query.scan) {
        this.back = false;
      }
     // console.log(this.$route.query.hasOwnProperty('refer_userid'))
      if(this.$route.query.hasOwnProperty('refer_userid')){
         this.refer_userid = this.$route.query.refer_userid;
      }
            console.log( 'this.refer_userid')

      console.log(this.$route.query)
      // if(this.userInfo.role == 1) {
      //   this.$router.replace('/doctor');
      // }
      this.$root.post('/getDoctorDep', {
        doc_id: this.$route.query.doc_id,
        pat_id: this.userInfo.user_id ? this.userInfo.user_id : 0
      }).then(data => {
        // 判断是否已经绑定了本医生
        if (data.is_bind == 1) {
          if (this.$route.query.scan) {
            let _this = this;
            this.$root.IMInit(this.userInfo.token, {
              connectSuccess() {
                _this.$router.replace('/patient');
              }
            })
          } else {
            this.$router.replace('/patient');
          }
        } else {
          this.docInfo = data;
          this.dataDone = true;
        }
      })
    },
    components: {
      xDialog
    },
    methods: {
      backToChoose() {
        this.$router.push('/patient/code-binding');
      },
      sendMessage() {
        let _this = this;
        this.$root.post('/createNewDocMsg', {
          pat_id: this.userInfo.user_id,
          doc_id: this.$route.query.doc_id
        }).then(data => {
          _this.$router.replace('/patient');
        });
      },
      bindingAction() {
        console.log(this.userInfo)

        let _this = this;
        this.$root.post('/goToBind', {
          user_id: this.userInfo.user_id || 0,
          doc_id: this.$route.query.doc_id,
          refer_userid:this.refer_userid,
          is_register: this.userInfo.token ? 1 : 0,
        }).then(data => {

          // status: 1:正常绑定 2:医生冲突 0:绑定出错
          if (data.status == 1) {
            if (this.userInfo.token) {
              this.$notify({
                message: '绑定成功',
                background: '#00848A'
              });
              if (this.$route.query.scan) {
                let _this = this;
                this.$root.IMInit(this.userInfo.token, {
                  connectSuccess() {
                    _this.sendMessage();
                  }
                })
              } else {
                _this.sendMessage();
              }
            } else {
              this.$router.push({
                path: '/patient/baseinfo',
                query: {
                  doc_id: this.$route.query.doc_id
                }
              });
            }
          } else if (data.status == 2) {
            this.dialogShow = true;
            this.oldDoc = data.username;
            this.oldId = data.id;
          } else {
            this.$notify(data.msg);
          }
        })

      },
      // 冲突医生弹窗确认
      confirm() {
        this.confirming = true;
        this.$root.post('/cancelDoctor', {
          id: this.oldId,
          doc_id: this.$route.query.doc_id
        }).then(data => {
          this.confirming = false;
          if (data.status == 1) {
            this.$notify({
              message: '绑定成功',
              background: '#00848A'
            });
            if (this.$route.query.scan) {
              let _this = this;
              this.$root.IMInit(this.userInfo.token, {
                connectSuccess() {
                  _this.$router.replace('/patient');
                }
              })
            } else {
              this.$router.replace('/patient');
            }
            // this.$router.push({path: '/patient/baseinfo', query: {doc_id: this.$route.query.doc_id}});
          } else {
            this.$notify(data.msg);
          }
        })

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Public/binding.vue